import { useState } from 'react';
import { Box } from '@chakra-ui/react';
import { Button, Colors, Text } from '@mercator-gcp/grout';
import BasicModal from 'components/elements/BasicModal';
import { useSendCompanyRequest } from 'hooks/useSendCompanyRequest';

const containerStyle = {
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  background: Colors.ArmyGreen100,
  paddingY: 'padding_16',
  marginTop: 'padding_16',
};

const requestButtonStyle = {
  marginTop: 'padding_8',
  display: 'inline-flex',
  color: Colors.ForestGreen900,
  textDecoration: 'underline',
  height: 'auto',
};

type Props = {
  companyNameQuery: string;
  showMessage?: boolean;
};

const RequestCompanyCTA = ({ companyNameQuery, showMessage = true }: Props) => {
  const [requestCompanyData, setRequestCompanyData] = useState<boolean>(false);

  const sendCompanyRequest = useSendCompanyRequest(companyNameQuery);

  return (
    <Box sx={containerStyle}>
      <Box>
        <Text>
          {showMessage
            ? `No results found for "${companyNameQuery}". Try searching using a different spelling or keyword.`
            : `Not exactly what you're looking for?`}
        </Text>
      </Box>
      <Button
        variant="unstyled"
        onClick={() => {
          setRequestCompanyData(true);
          sendCompanyRequest();
        }}
        sx={requestButtonStyle}
      >
        <Text>
          Request company data for <b>{` "${companyNameQuery}"`}</b>
        </Text>
      </Button>
      <BasicModal
        isOpen={requestCompanyData}
        onClose={() => setRequestCompanyData(false)}
      >
        <BasicModal.Body title="Request Received">
          <Text sx={{ textAlign: 'center' }}>
            {`Thank you for your feedback! You'll be notified when this data is available.`}
          </Text>
        </BasicModal.Body>
        <BasicModal.Footer>
          <Button
            onClick={() => {
              setRequestCompanyData(false);
            }}
          >
            Done
          </Button>
        </BasicModal.Footer>
      </BasicModal>
    </Box>
  );
};

export default RequestCompanyCTA;
